//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Header from "@/matrix/components/Header";
import Body from "@/matrix/components/Body";
import RowEditor from "@/matrix/components/body/RowEditor";
import { mapGetters, mapMutations } from "vuex";
import { isNull, isNumber } from 'util';

export default {
  name: "Public",
  components: {
    matrixHeader: Header,
    matrixBody: Body,
    matrixRowEditor: RowEditor
	},
	data() {
		return {
			top: true
		}
	},
  computed: {
    ...mapGetters(["computed", "filters", "authorized"]),
    cols() {
      let cols = this.computed.headers.reduce((_cols, header) => {
        if (header.hasOwnProperty('columnRatio') && isNumber(header.columnRatio) && header.columnRatio > 0) {
          _cols += `${header.columnRatio}fr `;
        } else if (header.editorType === "wysiwyg") _cols += "2fr ";
        else _cols += "1fr ";
        return _cols;
      }, "");

      if (this.authorized) cols += "1fr ";

      return { gridTemplateColumns: cols };
		}
  },
  methods: {
		...mapMutations(["clearFilters"]),
		scrollTop() {
			window.scrollTo({
				top: this.$el.offsetTop,
				behavior: 'smooth'
			})
		},
		checkTop() {
			if (window.scrollY > 100) {
				this.top = false
			}
			else {
				this.top = true
			}
		}
	},
	mounted() {
		this.checkTop()
		window.addEventListener('scroll', this.checkTop)
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.checkTop)
	}
};
